import { useEffect, useState } from "react";
import { UserEdit, UserProfile } from "../../models/UsersInfo";
import { useTranslation } from "react-i18next";
import { Button, Col, Dropdown, Form, Input, Row, Select, Checkbox } from "antd";
import "./ProfileForm.scss";
import {  editUserProfileData, isValidUsername } from "../../api/repositoryEP";
import { notification } from 'antd';
import { LoadingOutlined } from "@ant-design/icons";
import { UpdateAppLanguage } from "../../RoutesApp";
import { useSessionData } from "../../Contexts/SessionDataContext";
import UserSessionData from "../../models/UserSessionData";

interface ProfileFormProps {
    userData: UserEdit | null;
    setUserData: (userData: UserEdit | null) => void;
    languages: string[];
}

const ProfileForm =  (props : ProfileFormProps): JSX.Element => {
    const [form] = Form.useForm();
    const [usernameValue, setUsernameValue] = useState<string>(
        props.userData?.username !== undefined ? props.userData.username : ""
    );
    
    const [isValidUsernameInput, setIsValidUsernameInput] = useState<boolean>(true);
    const [isEmptyUsername, setIsEmptyUsername] = useState<boolean>(false);
    const [passwordValue, setPasswordValue] = useState<string>("");
    const { t } = useTranslation();
    const [loadingButton,setLoadingButton] = useState<boolean>(false);
    const { sessionData, setSessionData } = useSessionData();

    useEffect(() => {

      //  setUsernameValue(props.userData?.username)
    }, []);


    const handleInputBlur = async () => {
        setIsValidUsernameInput(true);
        if (usernameValue === "") {
             setIsEmptyUsername(true) 
        } else {
            setIsEmptyUsername(false)
            const response = await isValidUsername(usernameValue);
            if (response?.code === 200) {
                setIsValidUsernameInput(response.data);
            } else {
                setIsValidUsernameInput(false);
            }
        }
    }


    const handleChangeUsername = (e : any) => {
        setUsernameValue( e.target.value);
      };


            const onFinish = (values: any) => {
                if (isValidUsernameInput) {
                        setLoadingButton(true)
            const userData: UserProfile = {
                id: props.userData?.id || "",
                name: values.name,
                surname: values.surname,
                secondSurname: values["second-surname"],
                email: values.email,
                phone: values.phone,
                username: values.username,
                password: values.password,
                language: values.language,
            };
    
            editUserProfileData(userData)
                .then((response) => {
                    if (response?.type === 1) {
                        const previousLanguage = (props.userData?.language ?? "").split('-').pop()?.toLowerCase() ?? "";
                        const selectedLanguage = (values.language ?? "").split('-').pop()?.toLowerCase() ?? "";

                        if (props.userData) {
                            props.setUserData({
                                ...props.userData,
                                name: values.name,
                                surname: values.surname,
                                secondSurname: values["second-surname"],
                                email: values.email,
                                phone: values.phone,
                                username: values.username,
                                language: selectedLanguage,
                            });
                        }

                        if (sessionData?.userData) {
                            const updatedSessionData: UserSessionData = {
                                ...sessionData,
                                userData: {
                                    ...sessionData.userData,
                                    name: values.name,
                                    surname: values.surname,
                                    secondSurname: values["second-surname"],
                                    email: values.email,
                                    phone: values.phone,
                                    username: values.username,
                                    defaultLanguage: selectedLanguage,
                                }
                            };

                            setSessionData(updatedSessionData);
                            window.sessionStorage.setItem("user-data", JSON.stringify(updatedSessionData));
                        }

                        if (selectedLanguage && selectedLanguage !== previousLanguage) {
                            UpdateAppLanguage(selectedLanguage);
                        }
                    }
                })
                .finally(() => {
                    setLoadingButton(false)
                })
        } else {
            setLoadingButton(false)
        }
    };
      


   return (
        <div className="profile-info">
            <Form form={form} onFinish={onFinish} layout="vertical">
                <Row gutter={16}>
                    {props.userData && (<>
                        <Col xs={24} md={24}>
                            <h3>
                                {t("components.edit-users.general").toUpperCase()}
                            </h3>
                        </Col>
                        <Col xs={24} md={24}>
                            <Form.Item
                                name="name"
                                initialValue={props.userData.name}
                                label={t("components.edit-users.name")}
                                rules={[{ required: true, message: t("components.edit-users.validations.name-required") ?? "Name is required" }]}
                            >
                                <Input className="app-input"/>
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={24}>
                            <Form.Item
                                name="surname"
                                initialValue={props.userData.surname}
                                label={t("components.edit-users.surname")}
                                rules={[{ required: true, message: t("components.edit-users.validations.surname-required") ?? "Surname is required" }]}
                            >
                                <Input className="app-input"/>
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={24}>
                            <Form.Item
                                name="second-surname"
                                label={t("components.edit-users.second-surname") }
                                initialValue={props.userData.secondSurname}
                            >
                                <Input className="app-input" />
                            </Form.Item>
                        </Col>


                        <Col xs={24} md={24}>
                            <h3>
                                {t("components.edit-users.contact").toUpperCase()}
                            </h3>
                        </Col>
                        <Col xs={24} md={24}>
                            <Form.Item
                                name="email"
                                initialValue={props.userData.email}
                                label={t("components.edit-users.email")}
                                rules={[{ required: true, message: t("components.edit-users.validations.email-required") + "" }]}

                            >
                                <Input className="app-input" />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={24}>
                            <Form.Item
                                name="phone"
                                initialValue={props.userData.phone}
                                label={t("components.edit-users.phone")}
                                rules={[
                                    {
                                        pattern: /^[0-9]*$/,
                                        message: t("components.edit-users.validations.phone-numeric") + "",
                                    },
                                ]}
                            >
                                <Input className="app-input"/>
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={24}>
                            <h3>
                                {t("components.edit-users.access").toUpperCase()}
                            </h3>
                        </Col>


                        <Col xs={24} md={24}>
                            <Form.Item
                                name="password"
                                label={t("components.edit-users.password")}
                            >
                                <Input.Password className="app-input"
                                    value={passwordValue} />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={24}>
                            <Form.Item
                                name="repeat-password"
                                label={t("components.edit-users.repeat-password")}
                                dependencies={['password']}

                                rules={[
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            const passwordFieldValue = getFieldValue('password');
                                            if (!passwordFieldValue && !value) {
                                                // Ambos campos están vacíos, no hay error
                                                return Promise.resolve();
                                            }
                                            if (!value && passwordFieldValue) {
                                                return Promise.reject(t("components.edit-users.validations.password-required"))
                                            }
                                            if (!value || passwordFieldValue === value) {
                                                // El campo de repetir contraseña está vacío o coincide con el campo de contraseña
                                                return Promise.resolve();
                                            }
                                            // Los campos no coinciden
                                            return Promise.reject(t("components.edit-users.validations.password-not-match"));
                                        },
                                    }),
                                ]}
                            >
                                <Input.Password
                                    className="app-input"    />
                            </Form.Item>
                        </Col>


                        <Col xs={24} md={24}>

                            <Form.Item
                                name="username"
                                label={t("components.edit-users.username")}
                                initialValue={props.userData.username}
                                rules={[
                                    {
                                        required: true,
                                        message: t("components.edit-users.validations.username-required") + ""
                                    },
                                ]}
                                validateStatus={(!isValidUsernameInput || isEmptyUsername) ? 'error' : 'success'}
                                help={(!isValidUsernameInput
                                    && t("components.edit-users.validations.username-not-valid"))
                                    || (isEmptyUsername && t("components.edit-users.validations.username-required"))
                                }
                            >
                                <Input className="app-input"                                  
                                    value={usernameValue}
                                    onChange={handleChangeUsername}
                                    onBlur={handleInputBlur}
                                />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={24}>
                            <h3>
                                {t("components.edit-users.language").toUpperCase()}
                            </h3>
                        </Col>


                        <Col xs={24} md={24}>
                            <Form.Item name="language" initialValue={props.userData.language.toLowerCase()} rules={[{ required: true, message: t("components.edit-users.validations.language-required") + "" }]} >
                                <Select className="app-input" placeholder={t("components.edit-users.select")}>
                                    {props.languages.map((lang) => (
                                        <Select.Option key={lang} value={lang}>
                                            {t(`languages.${lang}`)}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>


                     


                        <Col xs={24} md={20}></Col>
                        <Col xs={24} md={4}>
                            <Form.Item style={{ textAlign: 'center' }}>
                                <Button className="app-button" htmlType="submit" disabled={loadingButton} style={{ width: "100%", alignItems:"right"}} >
                                {loadingButton ? <LoadingOutlined /> : t("components.button.save")}
                                </Button>
                            </Form.Item>
                        </Col>
                    </>

                    )}
                </Row>

            </Form>
        </div>
    );
};


export default ProfileForm;